import CryptoJS from 'crypto-js';

const SECRET_KEY = 'B6i8LK4ft9_1Qsra_IyOBonq-JCcjJ0rf62X4chPpFc='; // 🔒 Store this in a .env for real apps
const SECRET_KEY_PHP = 'cc2df854dfdbcc2df854dfdbcc2df85'; // 🔒 Store this in a .env for real apps

export const encryptUserData = (data) => {
  const jsonString = JSON.stringify(data);
  return CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
};

export const decryptUserData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {
    console.error('Decryption failed:', error);
    return null;
  }
};

export const decryptUserDataPhp = (cipherText) => {
  // console.log('ecryptUserDataPhp cipherText:', cipherText);
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY_PHP);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      // console.log('decryptUserDataPhp cipherText:', decryptedText);

      return JSON.parse(decryptedText);
    } catch (error) {
      console.error('Decryption failed:', error);
      return null;
    }
  };